import { LabeledCheckbox, LabeledInput } from '../components/fields';

import LoseBase from '../components/base/lose-base';

const FootballLose = () => {
  return (
    <LoseBase sportType="football">
      <div className="mt-4">
        <LabeledInput
          name="settings.lossPenaltySeries"
          placeholder="0 очков"
          label="В серии послематчевых пенальти"
          tooltip="Очки за проигрыш по пенальти (например, 1 очко за 'боевую ничью')."
          tooltipProps={{ position: 'input-right' }}
        />

        <LabeledCheckbox
          name="settings.technicalDefeatGoalsCount"
          label="Учёт голов при техническом поражении"
          containerClassName="d-flex align-items-center"
          tooltip="Засчитывать ли голы в статистику, если матч завершён техническим поражением (например, из-за неявки)."
          tooltipProps={{ position: 'input-right' }}
        />
      </div>
    </LoseBase>
  );
};

export default FootballLose;
